<div *ngIf="pythonCell">
  <div *ngIf="pythonCell.state === 'succeeded'" data-test="mode-notebook-cell-results-succeeded">
    <div
      *ngFor="let result of pythonCell.results; trackBy: token"
      [ngClass]="{ 'mode-notebook-cell-image': result.result_type === 'image' }"
      data-test="mode-notebook-cell-result"
    >
      <div
        *ngIf="result.type === 'text/html'"
        [modeNotebookCellHtml]="result.content"
        data-test="mode-notebook-cell-result-html"
      ></div>
      <div
        *ngIf="result.type === 'text/csv'"
        class="mode-notebook-cell-result-csv"
        data-test="mode-notebook-cell-result-csv"
      >
        <capra-button
          text="Export CSV"
          variant="secondary"
          color="neutral"
          size="medium"
          (clicked)="downloadCSV(result.content)"
        >
        </capra-button>
      </div>
      <img
        *ngIf="result.result_type === 'image'"
        [src]="result.content"
        (load)="imageLoaded(result)"
        data-test="mode-notebook-cell-result-image"
      />
      <div
        class="mode-notebook-cell-failed"
        *ngIf="result.result_type === 'error' && result.type === 'text/plain'"
        data-test="mode-notebook-cell-result-error"
      >
        <capra-icon icon="illo-error-dataset" height="64px" width="64px"></capra-icon>
        <p>Sorry, this content can't be displayed—<br />there's an error in the underlying code.</p>
        <a [attr.href]="pythonCell.vizReportRunLink" target="_blank">See what’s wrong</a>
      </div>
      <div
        class="mode-notebook-cell-results-text"
        *ngIf="
          result.type !== 'text/html' &&
          result.type !== 'text/csv' &&
          result.result_type !== 'image' &&
          !(result.result_type === 'error' && result.type === 'text/plain') &&
          result.result_type !== 'stderr'
        "
        [innerHtml]="result.content"
      ></div>
    </div>
  </div>
  <div
    *ngIf="pythonCell.state === 'loading' && viewer !== 'whiteLabel'"
    class="mode-notebook-cell-loading"
    data-test="mode-notebook-cell-results-loading"
  >
    <div class="placeholder-content">
      <!-- <svg-icon type="'ph-notebook'"></svg-icon> -->
      <p class="loading-message">
        Fetching your notebook data<span class="loading-dots"
          ><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span
        >
      </p>
    </div>
  </div>
  <div
    *ngIf="pythonCell.state === 'loading' && viewer === 'whiteLabel'"
    class="mode-notebook-cell-loading"
    data-test="mode-notebook-cell-results-loading-white-label"
  >
    <div class="mode-notebook-status-icon">
      <span class="loading-beacon gray-beacon lg-beacon"
        ><span class="pulse one"></span><span class="pulse two"></span><span class="pulse three"></span
        ><span class="spinner"></span
      ></span>
    </div>
    Notebook is still running. Hang tight!
  </div>
  <div
    *ngIf="pythonCell.state === 'empty'"
    class="mode-notebook-cell-failed"
    data-test="mode-notebook-cell-results-empty"
  >
    <i class="icon-refresh-gray mode-notebook-status-icon"></i>Cell has not been run yet
  </div>
  <div
    *ngIf="pythonCell.state === 'failed'"
    class="mode-notebook-cell-failed"
    data-test="mode-notebook-cell-results-failed"
  >
    <capra-icon icon="illo-error-dataset" height="64px" width="64px"></capra-icon>
    <p>Sorry, this block can't be displayed&mdash;<br />the underlying Notebook took too long to run.</p>
    <a href="{{ helpDocs.links['https://mode.com/help/articles/notebook/#faqs'] }}" target="_blank">Learn more</a> about
    run-time limits.
  </div>
  <div
    class="mode-notebook-cell-failed"
    *ngIf="pythonCell.state === 'skipped'"
    data-test="mode-notebook-cell-results-skipped"
  >
    <capra-icon icon="illo-error-dataset" height="64px" width="64px"></capra-icon>
    <p>Sorry, this block can't be displayed&mdash;<br />there's a problem with the underlying query.</p>
  </div>
</div>
